import { Theme } from '@mui/material/styles';
import { AvailabilityType } from 'api/services/availability/availability-service.schema';

export const isUnavailabilityType = (
  type: AvailabilityType
): type is 'unavailablePaid' | 'unavailableUnpaid' => {
  return type === 'unavailablePaid' || type === 'unavailableUnpaid';
};

export const shouldHideUnavailabilityCompensation = (worker?: {
  lenderCompanyName?: string | null;
}): boolean => Boolean(worker?.lenderCompanyName);

export const getUnavailabilityColor = (theme: Theme): string => {
  return theme.palette.lwBlack[100];
};
